import React, {memo, ReactNode} from 'react';


type Props = {
    onClick?: () => void;
    minWidth?: string;
    maxWidth?: string;
    height?: string;
    type?: 'submit' | 'reset' | 'button';
    disabled?: boolean;
    border?: boolean;
    text: string | ReactNode;
    color: 'green' | 'red' | 'black' | 'atlantis' | 'maroon';
    icon?: ReactNode;
}

const colorCssClass = {
    'atlantis': 'portal-provider-fat-atlantis-200-btn',
    'green': 'portal-provider-fat-green-btn',
    'red': 'portal-provider-fat-red-btn',
    'black': 'portal-provider-fat-black-btn',
    'maroon': 'portal-provider-fat-portal-maroon-btn',
}

export const FatOutlineButton = memo(function FatOutlineButton({
                                                                   text,
                                                                   onClick,
                                                                   type = 'button',
                                                                   color,
                                                                   disabled = false,
                                                                   minWidth = '',
                                                                   maxWidth = '',
                                                                   height,
                                                                   border = true,
                                                                   icon,
                                                                   }: Props) {
    const cssClass = colorCssClass[color];
    return (
        <button className={`
                ${cssClass}
                ${disabled ? "pointer-events-none select-none opacity-50 bg-gray-200" : ""}
                focus:outline-none
                rounded-full
                ${border ? "border-2" : "border-0"}
                w-full
                font-semibold
                p-2`}
                type={type}
                onClick={onClick}
                style={{
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    ...(height !== undefined ? {height} : {}),
                }}
        >
            <span className="relative flex items-center justify-center">
                {icon && <span className="absolute left-0 flex items-center">{icon}</span>}
                {text}
            </span>
        </button>
    );
});
